import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getStudent } from "../../features/slices/studentManagementReducer";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
  addNotifications,
  fetchNotifications,
} from "../../features/slices/notification";
import { toastService } from "../../utils/toastify";
const initialState = {
  userType: "",
  userId: "",
  title: "",
  content: "",
  errors: {},
};
const AddNotofication = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [userOptions, setUserOptions] = useState([]);
  const { userType, userId, title, content, errors } = iState;
  const dispatch = useDispatch();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
      errors: {
        ...prev.errors,
        [name]: "",
      },
    }));
  };
  const { studentData } = useSelector((state) => {
    return state?.student;
  });

  useEffect(() => {
    dispatch(getStudent({ limit: 10000 }));
  }, []);
  const handleValidate = () => {
    let formErrors = {};
    let isValid = true;
    if (!title.trim()) {
      formErrors.title = "Title is required.";
      isValid = false;
    }
    if (!content.trim()) {
      formErrors.content = "Content is required.";
      isValid = false;
    }
    if (!userType.trim()) {
      formErrors.userType = "User Type is required.";
      isValid = false;
    }
    if (userType == "Single" && !userId.trim()) {
      formErrors.userId = "User Id is required.";
      isValid = false;
    }
    setUpdateState((prev) => ({
      ...prev,
      errors: formErrors,
    }));
    return isValid;
  };
  const handleSendNotification = () => {
    if (handleValidate()) {
      const data = {
        title,
        content,
        userType,
        ...(userType === "Single" && { userId }),
        sendStatus: "SEND",
      };
      dispatch(addNotifications(data)).then((res) => {
        if (res?.payload?.code == 200) {
          dispatch(fetchNotifications());
          toastService.success("Notification sent successfully");
          setUpdateState(initialState);
        } else {
          toastService.error("Notification sent Failed");
        }
      });
    }
  };
  useEffect(() => {
    const Options = studentData?.result?.[0]?.paginationData?.map((item) => ({
      value: item._id,
      label: item.fullName,
    }));
    setUserOptions(Options);
  }, [studentData]);
  const handleChangeOption = (selectedOption) => {
    setUpdateState((prevState) => ({
      ...prevState,
      userId: selectedOption ? selectedOption.value : null,
      errors: {
        ...prevState.errors,
        userId: "",
      },
    }));
  };

  return (
    <>
      {" "}
      <div className="TitleBox Border">
        <h4 className="Title">New Message</h4>
      </div>
      <div className="CommonForm">
        <div className="d-flex justify-content-between ">
          <div className="form-group w-100">
            <label>User Type</label>
            <select
              className="form-control"
              name="userType"
              value={userType}
              onChange={handleChange}
            >
              <option>select</option>
              <option value="All">All</option>
              <option value="Single">Single</option>
            </select>
            {errors.userType && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.userType}
              </p>
            )}
          </div>
          <div className="form-group mx-4 mt-4">
            <label>Or</label>
          </div>
          <div className="form-group w-100">
            <label>Search User</label>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              name="userId"
              options={userOptions}
              isDisabled={userType === "All"}
              onChange={handleChangeOption}
            />
            {errors.userId && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.userId}
              </p>
            )}
          </div>
        </div>
        <div className="form-group">
          <label>Title</label>
          <input
            type="text"
            className="form-control"
            placeholder="Add Title"
            name="title"
            value={title}
            onChange={handleChange}
          />
          {errors.title && (
            <p className="d-flex justify-content-start text-danger mt-2 ">
              {errors.title}
            </p>
          )}
        </div>
        <div className="form-group">
          <label>Messages</label>
          <textarea
            className="form-control"
            placeholder="Write here..."
            rows={5}
            defaultValue={""}
            name="content"
            value={content}
            onChange={handleChange}
          />
          {errors.content && (
            <p className="d-flex justify-content-start text-danger mt-2 ">
              {errors.content}
            </p>
          )}
        </div>
        {/* <div className="form-group">
          <ul className="SocialCheck">
            <li>
              <label className="CheckBox">
                {" "}
                WhatsApp
                <input type="checkbox" />
                <span className="checkmark" />
              </label>
            </li>
            <li>
              <label className="CheckBox">
                {" "}
                SMS
                <input type="checkbox" />
                <span className="checkmark" />
              </label>
            </li>
            <li>
              <label className="CheckBox">
                {" "}
                Email
                <input type="checkbox" />
                <span className="checkmark" />
              </label>
            </li>
            <li>
              <label className="CheckBox">
                {" "}
                Web Notification
                <input type="checkbox" />
                <span className="checkmark" />
              </label>
            </li>
          </ul>
        </div> */}
        <div className="form-group">
          <button className="Button" onClick={handleSendNotification}>
            Send Message
          </button>
        </div>
      </div>
    </>
  );
};

export default AddNotofication;
